module.exports = __webpack_public_path__ + "static/img/loader-common.90927df.gif";